// A confirm drawn as a ClAlert (the app's showClConfirmModal, the Alerts
// board): Cancel is plain, the confirm bold or destructive.
//   if (await confirm({ title, body, confirmLabel, destructive })) ...
import { reactive } from "vue";

export const alertState = reactive({ open: false, title: "", body: "", actions: [], field: null, resolve: null });

// Opens a ClAlert and resolves with the chosen action's value (or the
// field's text for a prompt). Esc and the scrim resolve with `dismiss`.
export function openAlert({ title = "", body = "", actions = [], field = null, dismiss = null }) {
  if (alertState.resolve) alertState.resolve(alertState.dismiss);
  return new Promise((resolve) => {
    Object.assign(alertState, { open: true, title, body, actions, field, dismiss, resolve });
  });
}

export function closeAlert(value) {
  const done = alertState.resolve;
  Object.assign(alertState, { open: false, resolve: null });
  if (done) done(value);
}

export function confirm({ title, body = "", confirmLabel = "OK", cancelLabel = "Cancel", destructive = false } = {}) {
  return openAlert({
    title,
    body,
    dismiss: false,
    actions: [
      { label: cancelLabel, kind: "plain", value: false },
      { label: confirmLabel, kind: destructive ? "destructive" : "bold", value: true },
    ],
  });
}

export default confirm;
